if (! typeof ProductReviews !== 'function') {
    class ProductReviews extends HTMLElement {
        constructor() {
            super()

            this.observeReviews()
            this.widgetInnerProcessed = false
            this.reviewsPseudo = this.dataset.reviewsPseudo
            this.sectionId = this.dataset.sectionId
        }

        observeReviews() {
            const widgetSection = setInterval(() => {
                const widgetHeader = document.querySelector('.CarouselWidget__header .header__inner')
                if (widgetHeader && ! this.widgetInnerProcessed) {
                    clearInterval(widgetSection)
                    setTimeout(() => {
                        this.widgetInnerProcessed = true
                        const widgetInner = document.querySelector('.CarouselWidget__header .header__inner')
                        const widgetInnerChild = widgetInner.children
    
                        // remove some elements
                        if (typeof widgetInnerChild.forEach == 'function') {
                            widgetInnerChild.forEach((child, index) => {
                                if (index == 0) {
                                    // Change the header text and remove classes
                                    const childHeading = child.querySelector('.cssVar-header__heading')
                                    childHeading.textContent = 'Customer Reviews'
                                } else if (index == 2 || index == 4) {
                                    child.remove()
                                }
                            });
        
                            document.querySelector('.CarouselWidget__header .header__inner').children[3].remove()
        
                            // add the "Based on" text
                            const widgetInnerLabel = widgetInner.querySelector('.R-TextBody .cssVar-header__subheading')
                            widgetInnerLabel.textContent = 'Based on ' + widgetInnerLabel.textContent
        
                            // show the hidden reviews section
                            document.querySelector('.reviews__container').classList.add('reviews__container-active')
                            document.querySelector(this.sectionId).style.display = 'block'
                            document.querySelector('body').style.overflowX = 'hidden'
    
                            this.addWriteButton()
                            this.moveAuthorNameAndDate()
                        }
                    }, 2500);
                }
            }, 2500);
        }

        moveAuthorNameAndDate() {
            // move review author and date
            const widgetList = document.querySelector('.CarouselWidget__list .R-ReviewsList')
            if (widgetList) {
                const widgetListItems = widgetList.children
                if (typeof widgetListItems.forEach == 'function') {
                    widgetListItems.forEach((item) => {
                        const author = item.querySelector('.item__inner div div > .R-TextHeading')
                        const authorHTML = author.outerHTML
                        author.remove()
    
                        const date = item.querySelector('.item__inner .R-flex-row div .R-TextBody')
                        const dateHTML = date.outerHTML
                        date.remove()
    
                        const itemInnerExtra = `
                            <div class="item__extra">
                                <div class="item__extra-image">
                                    <img src="${this.reviewsPseudo}" alt="Reviews Pseudo"/>
                                </div>
                                <div class="item__extra-content">
                                    ${authorHTML}
                                    ${dateHTML}
                                </div>
                            </div>
                        `
    
                        const parser = new DOMParser()
                        const parsedHTML = parser.parseFromString(itemInnerExtra, 'text/html')
                        item.appendChild(parsedHTML.querySelector('.item__extra'))
                    })
                }
            }
        }

        addWriteButton() {
            const writeButton = document.createElement('button')
            writeButton.type = 'button'
            writeButton.classList.add('CarouselWidget__Button')
            writeButton.textContent = 'Write a review'

            const widgetInner = this.querySelector('.CarouselWidget__header .header__inner')
            widgetInner.appendChild(writeButton)
        }
    }

    if (typeof customElements.get('product-reviews') == 'undefined') {
        customElements.define('product-reviews', ProductReviews)
    }
}